import cn from "classnames";
import Tooltip from "rc-tooltip";
import React, { useState } from "react";

const CopyCoordinates = (props) => {
    const [copied, setCopied] = useState(false);
    const copyToClipboard = () => {
        if (copied) {
            return null;
        }
        setCopied(true);
        navigator.clipboard.writeText(props.coordinates);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };
    return (
        <Tooltip overlay={copied ? "Скопировано!" : "Скопировать координаты"} placement="bottom">
            <i
                className={cn("inline-icon mr-2 cursor-pointer", {
                    "icon-uEA11-place-holder": !copied,
                    "icon-uEA54-checkmark text-success": copied,
                })}
                onClick={copyToClipboard}
            />
        </Tooltip>
    );
};

export default CopyCoordinates;
